"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _CardActions = _interopRequireDefault(require("../Card/CardActions"));

var _CardContent = _interopRequireDefault(require("../Card/CardContent"));

var _CardHeader = _interopRequireDefault(require("../Card/CardHeader"));

var _CardHeaderAvatar = _interopRequireDefault(require("../Card/CardHeaderAvatar"));

var _CardHeaderTitle = _interopRequireDefault(require("../Card/CardHeaderTitle"));

var _Chip = _interopRequireDefault(require("../Chip/Chip"));

var _ChipFilter = _interopRequireDefault(require("../ChipFilter/ChipFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EventFeedItemInvite = function EventFeedItemInvite(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      authorAvatarUrl = _ref.authorAvatarUrl,
      accepted = _ref.accepted,
      onClickAccept = _ref.onClickAccept,
      onClickDelete = _ref.onClickDelete,
      showIndicator = _ref.showIndicator,
      tags = _ref.tags,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "subtitle", "authorAvatarUrl", "accepted", "onClickAccept", "onClickDelete", "showIndicator", "tags"]);

  var isRespondedTo = !onClickDelete || !onClickAccept;
  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      overflow: 'hidden'
    }
  }), (0, _themeUi.jsx)(_CardHeader["default"], null, (0, _themeUi.jsx)(_CardHeaderAvatar["default"], {
    url: authorAvatarUrl,
    showIndicator: showIndicator
  }), (0, _themeUi.jsx)(_CardHeaderTitle["default"], {
    title: title,
    subtitle: subtitle
  })), tags.length > 0 && (0, _themeUi.jsx)(_CardContent["default"], {
    variant: "avatar",
    sx: {
      mb: !isRespondedTo ? [0, 0] : [3, 3]
    }
  }, tags && tags.map(function (tag) {
    return typeof tag === 'string' ? (0, _themeUi.jsx)(_Chip["default"], {
      key: tag,
      sx: {
        mr: 2,
        mb: 2
      }
    }, tag) : (0, _themeUi.jsx)(_react.Fragment, null, tag.onClick ? (0, _themeUi.jsx)(_ChipFilter["default"], {
      onClick: tag.onClick,
      sx: {
        mr: 2,
        mb: 2,
        py: 0,
        height: 3
      },
      key: tag.label
    }, tag.label) : (0, _themeUi.jsx)(_Chip["default"], {
      sx: {
        mr: 2,
        mb: 2
      },
      key: tag.label
    }, tag.label));
  })), !isRespondedTo && (0, _themeUi.jsx)(_CardActions["default"], {
    variant: "avatar",
    sx: {
      borderTopStyle: 'none'
    }
  }, (0, _themeUi.jsx)(_Button["default"], {
    variant: "text",
    disabled: accepted,
    onClick: onClickDelete
  }, "Delete"), (0, _themeUi.jsx)(_Button["default"], {
    variant: "text",
    disabled: accepted,
    onClick: onClickAccept
  }, "Accept")));
};

EventFeedItemInvite.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  subtitle: _propTypes["default"].string,
  authorAvatarUrl: _propTypes["default"].string,
  accepted: _propTypes["default"].bool,
  onClickAccept: _propTypes["default"].func,
  onClickDelete: _propTypes["default"].func,
  showIndicator: _propTypes["default"].bool,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    label: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })]))
};
EventFeedItemInvite.defaultProps = {
  showIndicator: false,
  accepted: false,
  tags: []
};
var _default = EventFeedItemInvite;
exports["default"] = _default;